import React from 'react'
import SurveySection from '../SurveySection'
import { Tooltip } from 'react-tippy'
import { observer } from 'mobx-react'
import { ExistingMandateRow } from './ExistingMandateRow'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCaretUp,
  faCaretDown,
  faSquare,
  faCheckSquare,
} from '@fortawesome/free-solid-svg-icons'
import ibsStore from '../Stores/IbsSurveyStore'
import { sortObjects } from '../../helpers'
import { ExistingMandateMultiActionModal } from './Modals/ExistingMandateMultiActionModal'
library.add(faCaretUp)
library.add(faCaretDown)

export const ExistingMandatesTable = observer((props) => {
  let { columns, downloadFile } = props

  let [multiActionModalSettings, setMultiActionModalSettings] = React.useState({
    show: false,
    mode: '',
  })
  let [mandates, _setMandates] = React.useState(ibsStore.templateExisting)
  let [sortConfig, setSortConfig] = React.useState(null)

  let uploaded = 0,
    survey = 0,
    noStatus = 0

  const setMandates = (aInMandates) => {
    _setMandates(aInMandates)
    ibsStore.templateExisting = aInMandates
  }

  React.useEffect(() => {
    setMandates(ibsStore.templateExisting)
  }, [ibsStore.templateExisting])

  const requestSort = (column) => {
    const colId = column.id
    const colDataType = column.dataType

    let direction = 'ascending'
    if (
      sortConfig &&
      sortConfig.key === colId &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending'
    }

    setSortConfig({ key: colId, direction: direction, dataType: colDataType })
  }

  const selectMandate = (row) => {
    const updatedMandates = mandates.map((mandate) =>
      mandate.rowId === row.rowId && mandate.mandateId === row.mandateId
        ? { ...mandate, isSelected: !mandate.isSelected }
        : mandate
    )
    setMandates(updatedMandates)
  }
  /**
   * Toggles the selection state of all mandates.
   * If any mandate is currently selected, it will deselect all mandates.
   * If no mandate is currently selected, it will select all mandates.
   */
  const selectAllMandates = () => {
    let someMandatesAreSelected = mandates.some((mandate) => mandate.isSelected)
    let updatedMandates = mandates.map((mandate) => ({
      ...mandate,
      isSelected: !someMandatesAreSelected,
    }))
    setMandates(updatedMandates)
  }

  const updateIsClean = (mandateRowId, newIsCleanValue) => {
    let mandateIdx = mandates.findIndex(
      (mandate) => mandate.mandateRowId === mandateRowId
    )
    if (mandateIdx >= 0) {
      let mandatesCopy = [...mandates]
      mandatesCopy[mandateIdx].isClean = newIsCleanValue
      setMandates(mandatesCopy)
    }
  }

  if (mandates?.length > 0) {
    mandates.forEach((template) => {
      switch (template.status) {
        case 'Uploaded':
          uploaded++
          break
        case 'Survey':
          survey++
          break
        default:
          noStatus++
          break
      }
    })
  }

  return (
    <SurveySection>
      <section className='generalModal'>
        <ExistingMandateMultiActionModal
          multiActionModalSettings={multiActionModalSettings}
          setMultiActionModalSettings={setMultiActionModalSettings}
          mandates={mandates}
        />
      </section>

      <div className='titleRow'>
        <h3 className='sectionTitle'>
          Existing: All {mandates?.length}, Uploaded {uploaded}, Survey {survey}
          , Empty {noStatus}
        </h3>
        <div className='allActionsButtons'>
          <input
            type='button'
            className={
              mandates.filter((mandate) => mandate.isSelected).length > 0
                ? 'removeRow'
                : 'disabledRow'
            }
            style={{ width: 'auto', paddingLeft: '3px', paddingRight: '3px' }}
            value='Clear Values'
            onClick={() =>
              setMultiActionModalSettings({ show: true, mode: 'clearValues' })
            }
          />
          <input
            type='button'
            className={
              mandates.filter((mandate) => mandate.isSelected).length > 0
                ? 'removeRow'
                : 'disabledRow'
            }
            style={{ width: 'auto', paddingLeft: '3px', paddingRight: '3px' }}
            value='Remove Mandate'
            onClick={() =>
              setMultiActionModalSettings({ show: true, mode: 'remove' })
            }
          />

          <button
            className='selectAll addRow'
            style={{ paddingLeft: '1px' }}
            onClick={() => selectAllMandates()}
          >
            <FontAwesomeIcon
              icon={
                mandates.every((mandate) => mandate.isSelected)
                  ? faCheckSquare
                  : faSquare
              }
            />
          </button>
        </div>
      </div>
      <hr style={{ width: '100%', margin: '0px 0px 10px 0px' }} />

      <table className='NoAction'>
        <colgroup>
          {columns
            .filter((column) => column.hidden !== true)
            .map((column) => (
              <col span='1' style={{ width: `${column.width}%` }} />
            ))}
        </colgroup>
        <thead>
          <tr>
            {columns
              .filter((column) => column.hidden !== true)
              // .slice(0, -1)
              .map((column) => {
                let text = column.title
                let classList = []
                if (column.filterable) {
                  classList.push('clickable')
                  text = (
                    <>
                      {text}
                      <span style={{ float: 'right', marginRight: '0.5rem' }}>
                        <i className='fas fa-filter'></i>
                      </span>
                    </>
                  )
                }
                if (sortConfig?.key) {
                  if (sortConfig.key === column.id) {
                    text = (
                      <>
                        {text}
                        {sortConfig.direction === 'ascending' ? (
                          <FontAwesomeIcon
                            className='fa-caret'
                            icon='caret-up'
                          />
                        ) : (
                          <FontAwesomeIcon
                            className='fa-caret'
                            icon='caret-down'
                          />
                        )}
                      </>
                    )
                  }
                }
                if (column.tooltip2) {
                  text = (
                    <>
                      {text}
                      <Tooltip
                        position='left'
                        trigger='mouseenter'
                        animation='fade'
                        arrow='true'
                        size='small'
                        interactive='true'
                        hideOnClick='false'
                        html={column.tooltip2}
                        popperOptions={{
                          modifiers: {
                            preventOverflow: {
                              enabled: false,
                            },
                            flip: {
                              enabled: false,
                            },
                          },
                        }}
                      >
                        <i className='fas fa-info-circle fa-xs'></i>
                      </Tooltip>
                    </>
                  )
                }

                if (column.centered) classList.push('centerCell')
                return (
                  <th
                    className={classList.join(' ')}
                    onClick={() =>
                      column.filterable ? requestSort(column) : null
                    }
                  >
                    {text}
                  </th>
                )
              })}
            {/* Add extra empty header to account or space where Action would be */}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {mandates?.length > 0
            ? mandates
                .sort((a, b) => {
                  if (sortConfig?.key) {
                    return sortObjects(
                      a,
                      b,
                      sortConfig.key,
                      sortConfig.dataType,
                      sortConfig.direction
                    )
                  } else {
                    return 0
                  }
                })
                .map((row) => (
                  <ExistingMandateRow
                    row={row}
                    downloadFile={downloadFile}
                    updateIsClean={updateIsClean}
                    selectMandate={selectMandate}
                  />
                ))
            : null}
        </tbody>
      </table>
    </SurveySection>
  )
})
